module.exports = __webpack_public_path__ + "static/media/google-authentication.a32f0866.png";